import script from "./ShippingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingPage.vue?vue&type=script&setup=true&lang=js"

import "./ShippingPage.vue?vue&type=style&index=0&id=9185d64a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9185d64a"]])

export default __exports__